import React, { useState, useRef, useEffect } from "react";
import { Link } from "gatsby";
import InView from "react-intersection-observer";
import HeaderAnim from "../utils/animations/textRevealAnimation";
import { animationTypes, SlideInWithScroll } from "../utils/animations/slideInWithScroll";
import { motion, useTransform, useViewportScroll } from "framer-motion";
import Parallax from "../utils/animations/parallax";
import { directions } from "../utils/animations/animationConstants";
import LazyLoad from 'react-lazyload';

function TwoColumnTextImage(props) {
  const { header, subHeader, image, intro, classes, listItems, learnmorelink } = props.data;
  const [isVisible, setIsVisible] = useState(false);

  const triggers = [[1, 0.9], [0.97, 0.92], [0.94, 0.89], [0.91, 0.86]];

  return (
    <InView onChange={(inView) => setIsVisible(inView)} threshold={[0.2]}>
      <div className={`two-column-banner-section section-gap digital-experiences-section ${classes}`} id={props.id ? props.id : ''}>
        <div className="container">
          <div className="row d-flex flex-wrap">
            <Parallax classes="col banner-image-block" id="banner-image-block" direction={directions.LTR} length={100} opacity={true}>
              <LazyLoad>
                <img src={image} title="digital experiences" alt="digital product design experiences" />
              </LazyLoad>
            </Parallax>
            <div className="col banner-content-block">
              <p className="theme-color-title">{isVisible && <HeaderAnim header={header} />}</p>
              <h2 className="left-border h3">{subHeader}</h2>
              {intro}
              <ul className="list-style-line">
                {listItems && listItems.map((item, i) => {
                  return <Parallax id={`list-style-line-${i}`} key={i} direction={directions.RTL} length={50} opacity={true} triggers={triggers[0]}>
                    <motion.li>
                      <i className="list-icon">{item.icon}</i>
                      {item.header}
                    </motion.li>
                  </Parallax>;
                  //return <SlideInWithScroll key={i} elementTop={elementTop} clientHeight={clientHeight} children={jsx} triggerPoints={[triggers[i], triggers[i + 2]]} direction="RTL" />;
                })}
              </ul>
              <Parallax id="banner-button" direction={directions.RTL} length={70} triggers={[1, 0.9]} opacity={true}>
                <motion.div>
                  <Link to={learnmorelink} className="button button-black right-arrow">Learn More</Link>
                </motion.div>
              </Parallax>
            </div>
          </div>
        </div>
      </div>
    </InView >
  );
}

export default TwoColumnTextImage; 